// Printer

var fn_printer = function () {

    // Printable version  - js-btn--print
    $('.js-btn--print').on('click', function (e) {
        e.preventDefault()
        window.print()
    })

}